document.addEventListener("DOMContentLoaded", function () {

    let ATC_IN_PROGRESS = false;

    document.querySelectorAll('.collection-product-atc').forEach(function (button) {
        button.addEventListener('click', async function () {

            if (ATC_IN_PROGRESS) {
                console.log("ATC blocked — already in progress");
                return;
            }
            ATC_IN_PROGRESS = true;

            const btn = this;
            btn.classList.add('loading');

            const variantId = btn.dataset.variantId;

            if (!variantId) {
                console.error("❌ No variant ID on button.");
                btn.classList.remove('loading');
                ATC_IN_PROGRESS = false;
                return;
            }

            let sellingPlanId = null;

            // Only check subscription IF container exists
            const container = btn.closest('.subscription-container');

            if (container) {
                const productId = container.dataset.productId;

                const selectedRadio = container.querySelector(
                    `input[name="purchase-option-${productId}"]:checked`
                );
                const selected = selectedRadio?.value;

                const sp = container.querySelector('.selling-plan-select');

                if (selected === "subscription" && sp) {
                    sellingPlanId = sp.value;
                }
            }

            // Build payload
            const payload = {
                items: [
                    {
                        id: variantId,
                        quantity: 1,
                        ...(sellingPlanId ? { selling_plan: sellingPlanId } : {})
                    }
                ]
            };

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify(payload)
                });

                const text = await response.text();

                try {
                    JSON.parse(text);
                } catch (e) {
                    console.warn("Response was not valid JSON");
                }

                if (!response.ok) {
                    console.error("❌ Shopify returned an error:", text);
                }

                if (window.openSidecart) {
                    window.openSidecart();
                    if (window.fetchCart) window.fetchCart();
                }
            } catch (err) {
                console.error("❌ ATC Error:", err);
            } finally {
                btn.classList.remove('loading');
                ATC_IN_PROGRESS = false;
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
  // Loop through all subscription containers on the page
  document.querySelectorAll('.subscription-container').forEach(container => {
    const productId = container.dataset.productId;
    const atcPrice = container.querySelector('.collection-product-atc .coll-atc-price');
    const subRadio = container.querySelector(`#radio-sub-${productId}`);
    const oneTimeRadio = container.querySelector(`#radio-onetime-${productId}`);
    const subPriceEl = container.querySelector('.subscription-discount-price');
    const oneTimePriceEl = container.querySelector('.one-time-discount-price');
 
    if (!atcPrice || !subRadio || !oneTimeRadio) return;

    // Function to update the Add to Cart button price
    function updatePrice() {
      let newPrice;
      if (subRadio.checked) {
        newPrice = subPriceEl.dataset.discountedPrice || subPriceEl.textContent;
      } else if (oneTimeRadio.checked) {
        newPrice = oneTimePriceEl.dataset.onetimePrice || oneTimePriceEl.textContent;
      }

      if (newPrice) {
        atcPrice.textContent = newPrice.trim();
      }
    }

    // Attach 'change' listener to both radios
    [subRadio, oneTimeRadio].forEach(radio => {
      radio.addEventListener('change', updatePrice);
    });

    // Optional: attach click as fallback for some browsers
    [subRadio, oneTimeRadio].forEach(radio => {
      radio.addEventListener('click', updatePrice);
    });

    // Initialize price on page load
    updatePrice();
  });

});

